import React, { useState, useEffect } from "react";
import { useTheme } from '@repo/shared';
import DatePicker from "react-multi-date-picker"


import { Form, Container, Row, Col, Card, Button, Tabs, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import ConfigDataService from "../../services/config/ConfigService";
import LoadingSpinner from '../common/LoadingSpinner';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';

export default function SchoolYears({ setToken }) {
  const { appTheme } = useTheme();
  const [vacationDates, setVacationDates] = useState([]);
  const [semesterDates, setSemesterDates] = useState([]);
  const [loadingVacationDates, setLoadingVacationDates] = useState(true);

  const retrieveVacationDates = () => {
    setLoadingVacationDates(true);
    ConfigDataService.getVacationDates()
      .then((response) => {
        setVacationDates(response);
        setLoadingVacationDates(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadingVacationDates(false);
      });
  };

  const retrieveSemesterDates = () => {
    ConfigDataService.getSemesterDates()
      .then((response) => {
        console.log('got the semester dates');
        setSemesterDates(response);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    document.title = `${appTheme?.appName} - Config`;
    retrieveVacationDates();
    retrieveSemesterDates();
  }, []);

  const handleDeleteVacationDate = async (rowId, name) => {
    console.log(rowId, name);
    if (rowId.startsWith('t-')) {
      const filteredList = vacationDates.filter(p => p.id !== rowId);
      setVacationDates([...filteredList]);
    } else {
      //it is persisted
      try {
        setLoadingVacationDates(true);
        const incomingThemes = await ConfigDataService.deleteVacationDateRow(rowId);
        setVacationDates(incomingThemes);
        setLoadingVacationDates(false);
      } catch (e) {
        setLoadingVacationDates(false);
      }
    }
    //1 YourCellName
  };

  const addVacationDate = (forYear, actualYear) => {
    console.log('adding vacation date', forYear, actualYear);
    const newVacationDateRow = {id: `t-${vacationDates.length+1}`, startDate: `${actualYear}-01-01`, endDate: `${actualYear}-01-31`, year: forYear};
    saveVacationDateRow(newVacationDateRow);
    //setVacationDates([...vacationDates, {id: `t-${vacationDates.length+1}`, startDate: '2022-01-13', endDate: '2022-01-13', year: forYear}]);
  }

  const vacationDateColumns = [
    {
      dataField: 'startDate',
      text: 'Start Date',
      formatter: (cell) => {
        let dateObj = cell;
        if (!dateObj) {
          return '01/01/2021';
        }
        if (typeof cell !== 'object') {
          dateObj = new Date(cell);
        }
        return `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
      }, 
      editor: {
        type: Type.DATE
      },
      validator: (newValue, row, column) => {
        return true;
      }
    },
    {
      dataField: 'endDate',
      text: 'End Date',
      formatter: (cell) => {
        let dateObj = cell;
        if (!dateObj) {
          return '01/01/2021';
        }
        if (typeof cell !== 'object') {
          dateObj = new Date(cell);
        }
        return `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
      }, 
      editor: {
        type: Type.DATE
      },
      validator: (newValue, row, column) => {
        return true;
      }
    },
    {
      editable: false,
      text: 'Actions',
      formatter: (cellContent, row) => {
        return (
          <Button
            variant="danger"
            size="sm"
            onClick={() => handleDeleteVacationDate(row.id, row.name)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        );
      },
      headerStyle: { width: '80px', textAlign: 'center' },
      align: 'center',
    },
  ];

  const saveVacationDateRow = async (row) => {
    setLoadingVacationDates(true);
    try {
      const incomingVacationDates = await ConfigDataService.saveVacationDateRow(row);
      setVacationDates(incomingVacationDates);
      setLoadingVacationDates(false);
    } catch (e) {
      setLoadingVacationDates(false);
    }
  }
  const vacationDateCellSaved = async (oldValue, newValue, row, column) => {
    saveVacationDateRow(row);
  };

  const handleSemesterDateSubmit = async (date, forSemester, forYear) => {
    const semesterDateForYear = semesterDates.find(sd => sd.year === forYear);
    console.log('new date', date, forSemester, forYear);

    if (forSemester === 'winter') {
      semesterDateForYear.winterDate = new Date(date);
    } else if (forSemester === 'summer') {
      semesterDateForYear.summerDate = new Date(date);
    }

    const incomingSemesterDates = await ConfigDataService.saveSemesterDatesForYear(semesterDateForYear);
    setSemesterDates(incomingSemesterDates);
  }

  const handleSetActiveYear = async (forYear) => {
    const updatedSemesterDates = semesterDates.map(sd => ({
      ...sd,
      active: sd.year === forYear
    }));
    
    const updatedYear = updatedSemesterDates.find(sd => sd.year === forYear);
    const incomingSemesterDates = await ConfigDataService.saveSemesterDatesForYear(updatedYear);
    setSemesterDates(incomingSemesterDates);
  }

  const renderYearTabPanel = (forYear) => {
    const vacationDatesForYear = vacationDates ? vacationDates.filter(vd => vd.year === forYear).sort((a, b) => {
      return new Date(a.startDate) - new Date(b.startDate);
    }) : [];
    console.log('vacationDatesForYear', forYear, vacationDatesForYear);
    const semesterDateForYear = semesterDates.find(sd => sd.year === forYear) || {};
    const summerStartDate = semesterDateForYear.summerDate || Date.parse(`${forYear}-04-01`);
    const winterStartDate = semesterDateForYear.winterDate || Date.parse(`${forYear}-09-01`);
    const isActive = semesterDateForYear.active;
    
    return (
      <div className="p-4">
        <Card className="mb-4 shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <h5 className="mb-0">Details for {forYear}</h5>
              <Button
                variant={isActive ? "success" : "outline-secondary"}
                size="sm"
                onClick={() => handleSetActiveYear(forYear)}
              >
                {isActive ? '✓ Active Year' : 'Set as Active'}
              </Button>
            </div>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-500">Winter Semester Start</Form.Label>
                    <div style={{ padding: '8px', border: '1px solid #dee2e6', borderRadius: '4px', backgroundColor: '#fff' }}>
                      <DatePicker
                        onChange={(d) => handleSemesterDateSubmit(d, 'winter', forYear)}
                        value={winterStartDate}
                        placeholder="Select date"
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-500">Summer Semester Start</Form.Label>
                    <div style={{ padding: '8px', border: '1px solid #dee2e6', borderRadius: '4px', backgroundColor: '#fff' }}>
                      <DatePicker
                        onChange={(d) => handleSemesterDateSubmit(d, 'summer', forYear)}
                        value={summerStartDate}
                        placeholder="Select date"
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        <Card className="shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center justify-content-between">
            <h5 className="mb-0">Vacation Dates</h5>
            <Button
              variant="primary"
              size="sm"
              onClick={() => addVacationDate(forYear, forYear.substring(0, 4))}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" /> Add Vacation
            </Button>
          </Card.Header>
          <Card.Body className="p-0">
            
            <BootstrapTable
              keyField='id'
              data={vacationDatesForYear}
              columns={vacationDateColumns}
              noDataIndication={() => {
                return (
                  loadingVacationDates
                    ? <div className='p-4'><LoadingSpinner /></div>
                    : vacationDatesForYear.length === 0
                      ? <div style={{ width: '100%', textAlign: 'center', padding: '2rem', color: '#999' }}>No vacation dates defined for {forYear}</div>
                      : null
                )
              }}
              cellEdit={cellEditFactory({
                mode: 'click',
                blurToSave: true,
                autoSelectText: true,
                afterSaveCell: vacationDateCellSaved,
                beforeSaveCell: (oldValue, newValue, row, column) => { console.log('Before Saving Cell!!'); }
              })}
              striped
              hover
              bordered={false}
              classes="mb-0"
            />
          </Card.Body>
          <Card.Footer className="text-muted">
            Showing <strong>{vacationDatesForYear.length}</strong> vacation {vacationDatesForYear.length === 1 ? 'period' : 'periods'} for {forYear}.
          </Card.Footer>
        </Card>
      </div>
    );
  };

  return (
    <Container className="py-2 py-lg-4">
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center gap-2">
                <h2 className="mb-0">School Years</h2>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              {semesterDates && semesterDates.length > 0 ? (
                <Tabs defaultActiveKey={semesterDates[0]?.year} className="border-bottom">
                  {semesterDates.map(sd => (
                    <Tab key={sd.year} eventKey={sd.year} title={`${sd.year} ${sd.active ? '✅' : ''  }`} style={{ color: 'var(--page-font-color) !important' }}>
                      {renderYearTabPanel(sd.year)}
                    </Tab>
                  ))}
                </Tabs>
              ) : (
                <div className="p-4 text-center text-muted">Loading school years...</div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
  
}
